export default function ({ store }) {
  store.commit("global/setSplashVideoUrl");
  store.commit("profiles/setFilters", { gender: ["female"] });
}
